import { render, staticRenderFns } from "./it-chart.vue?vue&type=template&id=5ba35df6&"
import script from "./it-chart.vue?vue&type=script&lang=js&"
export * from "./it-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports